module.exports = __webpack_public_path__ + "img/CS-UL-HD_Overview-Front_1.8afe0802.jpg";